import { queryOptions } from '@tanstack/react-query';

import { apiGetDefaultStories, apiGetStoryById } from './api';
import { Language } from './utils';

export const storyByIdQueryOptions = (id: string) => {
  return queryOptions({
    queryKey: ['stories', { id }],
    queryFn: () => apiGetStoryById(id),
  });
};

export const defaultStoriesByLocaleOptions = (locale: Language) => {
  return queryOptions({
    queryKey: ['stories', locale],
    queryFn: () => apiGetDefaultStories({ locale }),
  });
};
